import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Product, User } from 'src/app/_models';
import { BasketService } from 'src/app/_services/basket.service';
import { ProductFormatOptionsModalComponent } from '../product-format-options-modal/product-format-options-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService, CatalogService } from 'src/app/_services';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment.prod';
import { ProductBatchModalComponent } from '../product-batch-modal/product-batch-modal.component';

declare const $  : any;

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.css']
})
export class ProductAddComponent implements OnInit {

  @Input() product : Product;
  @Input() formatOptionsModal: ProductFormatOptionsModalComponent;
  @Input() batchModal: ProductBatchModalComponent;

  public debouncer : any
  public currentUser : User;

  constructor(
    public basket : BasketService,
    public translate : TranslateService,
    public auth : AuthenticationService,
    public toastr : ToastrService,
    public catalog : CatalogService
  ) { 

  }
  
  ngOnInit() {
    this.auth.currentUser.subscribe(user =>{
      this.currentUser = user;
    });

  }

  public get inBatch() : boolean {
    return this.catalog.currentCategory && this.catalog.currentCategory.batch_cents > 0
  }
  

  add (product : Product){

    if (this.inBatch){
      this.batchModal.setCategory (this.catalog.currentCategory);
      $('#modal-batch-product').modal('show');      
    } else {
      if (product.has_format){
        this.formatOptionsModal.setProduct (product);
        $('#modal-format-options-product').modal('show');
      } else { 
          this.basket.more(product).subscribe( r =>{
          }, error => {
          });
      }
    }
  }

  more(product : Product){
    if (this.inBatch){
      this.batchModal.setCategory (this.catalog.currentCategory);
      $('#modal-batch-product').modal('show');      
    } else {
      if (product.has_format){
        this.formatOptionsModal.setProduct (product);
        $('#modal-format-options-product').modal('show');
      } else { 
        this.basket.more(product).subscribe();
      }
    }
  }

  less(product : Product){
    if (this.inBatch){
      this.batchModal.setCategory (this.catalog.currentCategory);
      $('#modal-batch-product').modal('show');      
    } else {
      if (product.has_format){
        this.formatOptionsModal.setProduct (product);
        $('#modal-format-options-product').modal('show');
      } else { 
        this.basket.less(product).subscribe();
      }
    }
  }

  updateQuantity(target: any) : any {
    clearTimeout(this.debouncer); 
    this.debouncer = setTimeout(() => {
      this.basket.setQuantity(this.product, target.value).subscribe(result =>{
        target.value = this.basket.inBasket(this.product).quantity;
      });
    }, environment.UPDATE_QTY_TIMEOUT);
    return this.debouncer;
  }

  immediateUpdateQuantity(target: any) : any {
    clearTimeout(this.debouncer); 
    this.basket.setQuantity(this.product,target.value).subscribe(result =>{
      target.value = this.basket.inBasket(this.product).quantity;
    });
  }

  
}
